import PeopleSchemaAdapter from './base';

export default class Set extends PeopleSchemaAdapter {
  modelNamePlural = 'sets';
}
